import React, { ReactNode } from 'react';
import { EnumMember, ParameterType, Type } from '../apiref/apireftypes';

export function createTrainingMethod() : ParameterType
{
    const members = [{
            name        : "GCE",
            id          : "gce",
            description :
                <>
                    <p>This is our most stabile learning method, it is a combination of DeepSeeks GPRO and SFT(Supervised Fine-tuning which allow you
                       to traing multiple responses with rewards in the same way as the GRPO algorithm. 
                    </p>
                </>
        },
        {
            name        : "Direct Preference Optimization",
            id          : "dpo",
            description :
                <>
                    <p>Direct Preference Optimization is a reinforcement learning method that trains 
                       language models to align with human preferences without requiring a separate reward model. Unlike traditional RLHF (Reinforcement Learning from Human Feedback) which uses PPO and requires fitting a reward model, DPO optimizes the model directly using a simple binary cross-entropy loss on preference data. This makes it more stable, computationally efficient, and easier to implement while achieving comparable or better performance than PPO-based methods.
                    </p>
                    <p><strong>Research:</strong> <a href="https://arxiv.org/abs/2305.18290">https://arxiv.org/abs/2305.18290</a></p>
                </>
        },
        {
            name        : "GRPO (Group Relative Policy Optimization)",
            id          : "grpo",
            description :
                <>
                    <p>Group Relative Policy Optimization is a variant of Proximal Policy Optimization that enhances reasoning capabilities while reducing memory consumption. GRPO eliminates the need for a separate value function (critic network) and instead generates multiple outputs for each prompt, computing advantages relative to the group's average reward. This approach is particularly effective for mathematical reasoning and complex problem-solving tasks, as demonstrated in DeepSeek-Math and DeepSeek-R1 models.</p>
                    <p><strong>Research:</strong> <a href="https://arxiv.org/abs/2402.03300">https://arxiv.org/abs/2402.03300</a></p>
                </>
        },
        {
            name      : "SFT (Supervised Fine-Tuning)",
            id         : "sft",
            description : 
                <>
                    <p>Supervised Fine-Tuning is the foundational method for adapting pre-trained language models to specific tasks or domains using labeled data. The model is trained on curated examples of desired behavior using a standard language modeling objective (next token prediction). SFT is typically the first step in the alignment process before applying more advanced techniques like DPO or GRPO. It's computationally efficient and effective for teaching models to follow instructions, adopt specific writing styles, or gain domain expertise.</p>
                    <p><strong>Research:</strong> <a href="https://arxiv.org/abs/2310.05492">https://arxiv.org/abs/2310.05492</a></p>
                </>
        }
    ];

    const desc = (<>
        <h3>Training Method</h3>
        Different training models are implemented. 
        The recomended method is "gce" which is a improved "sft" method that makes it possible to learn multiple responses at the same time.

        { renderEnumMembers(members) }
        </>);

    return {
        id          : "TrainingMethod",
        name        : "TrainingMethod",
        description : desc,
        type        : Type.Enum,
        enumMembers : members
    }
}

function renderEnumMembers(members : EnumMember[]) : ReactNode
{
    return (<>
        { members.map((item) => {
            return <React.Fragment key={item.id}>
                <h3>{ item.name }</h3>
                <p><strong>Value:</strong>{ item.id } </p>
                {item.description}
                </React.Fragment>;
        })}


        </>);
}

